import { defineComponent as _defineComponent } from 'vue'
import { useLetterFormatData } from '@/composables/format-edit/useLetterFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'LetterResumeListCard',
  props: {
    currentCardId: null,
    previewErrors: null
  },
  setup(__props: any) {



const formatData = useLetterFormatData()

return { __sfc: true,formatData }
}

})